import { recruiterApi } from "../../redux/api/axiosInstance";

export interface TeamsMeetingInvitePayload {
  organizerEmail: string;
  attendeeEmail: string;
  startUtc: string;
  endUtc: string;
  subject: string;
  description: string;
}

export interface TeamsMeetingResponse {
  // Microsoft Graph Event fields
  id: string;
  subject: string;
  start?: {
    dateTime: string;
    timeZone: string;
  };
  end?: {
    dateTime: string;
    timeZone: string;
  };
  startDateTime?: string;
  endDateTime?: string;
  joinWebUrl?: string;
  onlineMeeting?: {
    joinUrl: string;
  };
  meetingId?: string;
  organizerEmail?: string;
  attendeeEmail?: string;
  startUtc?: string;
  endUtc?: string;
  description?: string;
  meetingUrl?: string;
  joinUrl?: string;
  [key: string]: any;
}

export interface OAuthCallbackParams {
  code: string;
  state: string;
}

export interface TeamsStatusResponse {
  isAuthenticated?: boolean;
  teamsConnected?: boolean;
  valid?: boolean;
  userEmail?: string;
  message?: string;
  status?: string;
  [key: string]: any;
}

export interface TeamsLoginResponse {
  authUrl?: string;
  loginUrl?: string;
  redirectUrl?: string;
  url?: string;
  message?: string;
  [key: string]: any;
}

export const getAllTeamsMeetings = async (): Promise<TeamsMeetingResponse[]> => {
  try {
    const response = await recruiterApi.get('TeamsMeetings/meetings');
    return response.data;
  } catch (error: any) {
    console.error('Error fetching all Teams meetings:', error);
    throw error;
  }
};

export const getUpcomingWeekMeetings = async (): Promise<TeamsMeetingResponse[]> => {
  try {
    const response = await recruiterApi.get('TeamsMeetings/upcoming-week');
    return response.data;
  } catch (error: any) {
    console.error('Error fetching upcoming week Teams meetings:', error);
    throw error;
  }
};

export const getTeamsMeetingById = async (meetingId: string): Promise<TeamsMeetingResponse> => {
  try {
    const response = await recruiterApi.get(`TeamsMeetings/meetings/${meetingId}`);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching Teams meeting by ID:', error);
    throw error;
  }
};

export const createTeamsMeetingInvite = async (payload: TeamsMeetingInvitePayload): Promise<any> => {
  try {
    const response = await recruiterApi.post('TeamsMeetings/invite', payload);
    return response.data;
  } catch (error: any) {
    console.error('Error creating Teams meeting invite:', error);
    throw error;
  }
};

// OAuth Services
export const initiateTeamsLogin = async (): Promise<TeamsLoginResponse> => {
  try {
    const response = await recruiterApi.get('OAuth/teams-login');
    return response.data;
  } catch (error: any) {
    console.error('Error initiating Teams login:', error);
    throw error;
  }
};

export const handleOAuthCallback = async (code: string, state: string): Promise<any> => {
  try {
    const response = await recruiterApi.get('OAuth/callback', {
      params: {
        code,
        state
      }
    });
    return response.data;
  } catch (error: any) {
    console.error('Error handling OAuth callback:', error);
    throw error;
  }
};

export const getTeamsAuthStatus = async (): Promise<TeamsStatusResponse> => {
  try {
    const response = await recruiterApi.get('OAuth/teams-status');
    return response.data;
  } catch (error: any) {
    console.error('Error fetching Teams auth status:', error);
    throw error;
  }
};